"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uploadOptionsBase = _interopRequireDefault(require("./upload-options-base"));

var _httpClient = _interopRequireDefault(require("./http/http-client"));

var _fileUploadResult = _interopRequireDefault(require("./file-upload-result"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DEFAULT_PROGRESS_THRESHOLD = 500;
/**
 * The purpose of this class is to coordinate the complete transfer of a file,
 * based on a process that transfers said file in multiple parts.
 *
 * This class will handle determining when a file starts transferring, and
 * when a file finishes transferring, either successfully or in failure.
 */

var FileTransferHandler = /*#__PURE__*/function (_UploadOptionsBase) {
  _inherits(FileTransferHandler, _UploadOptionsBase);

  var _super = _createSuper(FileTransferHandler);

  /**
   * Constructs a new instance of the handler.
   * @param {object} options Direct binary process level options.
   * @param {DirectBinaryUploadOptions} uploadOptions Used to retrieve
   *  various information about the current upload.
   * @param {HttpClient} httpClient Used to check whether files have
   *  been cancelled or not.
   */
  function FileTransferHandler(options, uploadOptions, httpClient) {
    var _this;

    _classCallCheck(this, FileTransferHandler);

    _this = _super.call(this, options, uploadOptions);
    _this.httpClient = httpClient;

    if (!_this.httpClient) {
      _this.httpClient = new _httpClient.default(options, uploadOptions);
    }

    _this.fileUploadResults = {};
    _this.endedFileUploadResults = {};
    _this.lastProgress = 0;
    _this.totalFileProgress = {};
    return _this;
  }
  /**
   * Retrieves the HTTP client that the handler is using to monitor
   * cancellations.
   */


  _createClass(FileTransferHandler, [{
    key: "getHttpClient",
    value: function getHttpClient() {
      return this.httpClient;
    }
    /**
     * This method is intended to be called whenever a file part begins uploading. The handler
     * will determine if it's the first part of a new file, and perform actions accordingly.
     * @param {UploadResult} uploadResult Result for the part's file will be added when
     *  necessary.
     * @param {InitResponseFileInfo} initResponseFileInfo Used to retrieve information about
     *  the file.
     * @returns {boolean} Returns true if processing of the part should continue. If processing
     *  should stop (i.e. in the case where the file was cancelled) then the return value will
     *  be false.
     */

  }, {
    key: "partTransferStarted",
    value: function () {
      var _partTransferStarted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(uploadResult, initResponseFileInfo) {
        var _this2 = this;

        var filePath;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                filePath = initResponseFileInfo.getTargetFilePath();
                _context2.next = 3;
                return (0, _utils.getLock)(filePath, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var fileUploadResult;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (_this2.fileUploadResults[filePath]) {
                            _context.next = 9;
                            break;
                          }

                          fileUploadResult = new _fileUploadResult.default(_this2.getOptions(), _this2.getUploadOptions(), initResponseFileInfo);
                          _this2.fileUploadResults[filePath] = fileUploadResult;

                          _this2.logInfo("Starting to upload file ".concat(filePath));

                          fileUploadResult.startTimer();
                          uploadResult.addFileUploadResult(fileUploadResult);

                          if (_this2.httpClient.isCancelled(filePath)) {
                            _context.next = 9;
                            break;
                          }

                          _context.next = 9;
                          return _this2._doFileTransferStarted(fileUploadResult, initResponseFileInfo);

                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));

              case 3:
                return _context2.abrupt("return", !this.httpClient.isCancelled(filePath) && this.fileUploadResults[filePath].isSuccessful());

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function partTransferStarted(_x, _x2) {
        return _partTransferStarted.apply(this, arguments);
      }

      return partTransferStarted;
    }()
    /**
     * This method is intended to be called whenever a file's part finishing transferring. The
     * method will determine the status of the file (i.e. completed, failed, or cancelled),
     * and perform actions accordingly.
     * @param {InitResponseFileInfo} initResponseFileInfo Used to retrieve information about
     *  the file.
     * @param {PartResult} [partResult] If specified, will be added to the file's results.
     */

  }, {
    key: "partTransferEnded",
    value: function () {
      var _partTransferEnded = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(initResponseFileInfo) {
        var _this3 = this;

        var partResult,
            filePath,
            handler,
            fileUploadResult,
            _args3 = arguments;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                partResult = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : false;
                filePath = initResponseFileInfo.getTargetFilePath();
                handler = false;
                fileUploadResult = this.fileUploadResults[filePath];
                _context3.next = 6;
                return (0, _utils.getLock)(filePath, function () {
                  if (fileUploadResult && !_this3.endedFileUploadResults[filePath]) {
                    if (partResult) {
                      fileUploadResult.addPartResult(partResult);
                    }

                    if (_this3.httpClient.isCancelled(filePath)) {
                      _this3.logInfo("File upload for ".concat(filePath, " was cancelled by user"));

                      fileUploadResult.setIsCancelled(true);
                      handler = _this3._doFileTransferCancelled;
                    } else if (!fileUploadResult.isSuccessful()) {
                      _this3.logInfo("File upload for ".concat(filePath, " failed due to error"));

                      handler = _this3._doFileTransferError;
                    } else if (initResponseFileInfo.getFilePartCount() === fileUploadResult.getPartCount()) {
                      _this3.logInfo("Finished uploading file ".concat(filePath));

                      handler = _this3._doFileTransferSucceeded;
                    }
                  }

                  if (handler) {
                    _this3.endedFileUploadResults[filePath] = true;
                  }
                });

              case 6:
                if (!handler) {
                  _context3.next = 10;
                  break;
                }

                fileUploadResult.stopTimer();
                _context3.next = 10;
                return handler.call(this, fileUploadResult, initResponseFileInfo);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function partTransferEnded(_x3) {
        return _partTransferEnded.apply(this, arguments);
      }

      return partTransferEnded;
    }()
    /**
     * This method is intended to be called whenever meaningful progress has been made
     * in the transfer of part of a file. The method will keep a running total of the
     * amount of data that has transferred for the file, and will ensure that consumers
     * are notified of the progress on a periodic basis.
     * @param {InitResponseFileInfo} initResponseFileInfo Used to retrieve information
     *  about the file.
     * @param {object} progressData Information about the progress.
     * @param {number} progressData.transferred Number of bytes that have transferred for the
     *  file since the last time the progress event was called for that file.
     */

  }, {
    key: "partTransferProgress",
    value: function () {
      var _partTransferProgress = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(initResponseFileInfo, progressData) {
        var _this4 = this;

        var filePath, transferred, fileUploadResult, fileProgress;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                filePath = initResponseFileInfo.getTargetFilePath();
                transferred = progressData.transferred;
                _context5.next = 4;
                return (0, _utils.getLock)(filePath, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                  var now, _this4$getOptions, _this4$getOptions$pro, progressDelay;

                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          fileUploadResult = _this4.fileUploadResults[filePath];

                          if (fileUploadResult && !_this4.endedFileUploadResults[filePath]) {
                            if (!_this4.totalFileProgress[filePath]) {
                              _this4.totalFileProgress[filePath] = {
                                transferred: 0
                              };
                            } // keep track of total bytes transferred across all parts for the file


                            _this4.totalFileProgress[filePath].transferred += transferred;
                            now = new Date().getTime();
                            _this4$getOptions = _this4.getOptions(), _this4$getOptions$pro = _this4$getOptions.progressDelay, progressDelay = _this4$getOptions$pro === void 0 ? DEFAULT_PROGRESS_THRESHOLD : _this4$getOptions$pro;

                            if (progressDelay <= 0 || now - _this4.lastProgress > progressDelay) {
                              _this4.lastProgress = now;
                              fileProgress = _this4.totalFileProgress[filePath];
                            }
                          }

                        case 2:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                })));

              case 4:
                if (!fileProgress) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return", this._doFileTransferProgress(fileUploadResult, initResponseFileInfo, _objectSpread({}, progressData, {}, fileProgress)));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function partTransferProgress(_x4, _x5) {
        return _partTransferProgress.apply(this, arguments);
      }

      return partTransferProgress;
    }()
    /**
     * This method will be called once if all parts of a file transfer successfully. Only one of
     * _doFileTransferSucceeded, _doFileTransferError, or _doFileTransferCancelled will be
     * called, depending on the status of the file transfer. The default implementation does nothing.
     * @param {FileUploadResult} fileUploadResult Statistics about the overall transfer process
     *  of the file.
     * @param {InitResponseFileInfo} initResponseFileInfo Provides various information about the
     *  file.
     */

  }, {
    key: "_doFileTransferSucceeded",
    value: function () {
      var _doFileTransferSucceeded2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.logWarn('_doFileTransferSucceeded: unimplemented parent method called.');

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _doFileTransferSucceeded() {
        return _doFileTransferSucceeded2.apply(this, arguments);
      }

      return _doFileTransferSucceeded;
    }()
    /**
     * This method will be called once if any of the file's parts fails to transfer. Only one of
     * _doFileTransferSucceeded, _doFileTransferError, or _doFileTransferCancelled will be
     * called, depending on the status of the file transfer. The default implementation does nothing.
     * @param {FileUploadResult} fileUploadResult Statistics about the overall transfer process
     *  of the file.
     * @param {InitResponseFileInfo} initResponseFileInfo Provides various information about the
     *  file.
     */

  }, {
    key: "_doFileTransferError",
    value: function () {
      var _doFileTransferError2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.logWarn('_doFileTransferError: unimplemented parent method called.');

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _doFileTransferError() {
        return _doFileTransferError2.apply(this, arguments);
      }

      return _doFileTransferError;
    }()
    /**
     * This method will be called once if a file's transfer is cancelled by the user. Only one of
     * _doFileTransferSucceeded, _doFileTransferError, or _doFileTransferCancelled will be
     * called, depending on the status of the file transfer. The default implementation does nothing.
     * @param {FileUploadResult} fileUploadResult Statistics about the overall transfer process
     *  of the file.
     * @param {InitResponseFileInfo} initResponseFileInfo Provides various information about the
     *  file.
     */

  }, {
    key: "_doFileTransferCancelled",
    value: function () {
      var _doFileTransferCancelled2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.logWarn('_doFileTransferCancelled: unimplemented parent method called.');

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function _doFileTransferCancelled() {
        return _doFileTransferCancelled2.apply(this, arguments);
      }

      return _doFileTransferCancelled;
    }()
    /**
     * This method will be called once when one of file's parts begins to transfer. The default
     * implementation does nothing.
     * @param {FileUploadResult} fileUploadResult Statistics about the overall transfer process
     *  of the file.
     * @param {InitResponseFileInfo} initResponseFileInfo Provides various information about the
     *  file.
     */

  }, {
    key: "_doFileTransferStarted",
    value: function () {
      var _doFileTransferStarted2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.logWarn('_doFileTransferStarted: unimplemented parent method called.');

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function _doFileTransferStarted() {
        return _doFileTransferStarted2.apply(this, arguments);
      }

      return _doFileTransferStarted;
    }()
    /**
     * This method will be called on a metered basis when progress is made while transferring any of
     * the file's parts. The default implementation does nothing.
     * @param {FileUploadResult} fileUploadResult Statistics about the overall transfer process
     *  of the file.
     * @param {InitResponseFileInfo} initResponseFileInfo Provides various information about the
     *  file.
     * @param {number} totalTransferredBytes The total number of bytes that have been transferred for
     *  the file.
     */

  }, {
    key: "_doFileTransferProgress",
    value: function () {
      var _doFileTransferProgress2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.logWarn('_doFileTransferProgress: unimplemented parent method called.');

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function _doFileTransferProgress() {
        return _doFileTransferProgress2.apply(this, arguments);
      }

      return _doFileTransferProgress;
    }()
  }]);

  return FileTransferHandler;
}(_uploadOptionsBase.default);

exports.default = FileTransferHandler;